export default "__VITE_ASSET__BeiMgFOw__"